import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
  alternativeOfferConfirmationJobMock,
  alternativeOfferInProgressJobMock,
  cancelAndRefundOrderMockOutboundDisruptedManuallyRefundable,
  getAlternativeOffersMockDisruptedInbound,
  getOrderEligibilitiesMockDisruptedOutboundManuallyRefundable,
  retrieveOrderMockDisruptedOutbound,
} from '../../../mock/data/index';
import {
  flightDisruptionWarning,
} from '../../../mock/dictionaries';

export const disruptedOutboundManuallyRefundableMock: MockMap = {
  retrieveOrder: [
    createMockData(retrieveOrderMockDisruptedOutbound, [], [flightDisruptionWarning])
  ],
  getOrderEligibilities: [
    {
      mockData: getOrderEligibilitiesMockDisruptedOutboundManuallyRefundable
    }
  ],
  cancelAndRefundOrder: [
    {
      mockData: cancelAndRefundOrderMockOutboundDisruptedManuallyRefundable,
      getResponse: () => {
        return new Response(JSON.stringify(cancelAndRefundOrderMockOutboundDisruptedManuallyRefundable), {
          status: 201
        });
      }
    }
  ],
  getAlternativeOffers: [createMockData(getAlternativeOffersMockDisruptedInbound)],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(alternativeOfferInProgressJobMock)],
  getAlternativeOfferConfirmationJob: [createMockData(alternativeOfferConfirmationJobMock)],
  acknowledge: [createMockData(acknowledgeSuccess)]
};
